import { createFileRoute } from '@tanstack/react-router'
import { PoolReduce } from '@/features/trade/pool/PoolReduce'

function PoolReducePage() {
  const { item } = Route.useParams()
  const parsed = JSON.parse(decodeURIComponent(item))
  return <PoolReduce item={parsed} />
}

export const Route = createFileRoute('/_app/pool/reduce/$item')({
  component: PoolReducePage,
})
